import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5954443c&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/test-e-youhuo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5954443c')) {
      api.createRecord('5954443c', component.options)
    } else {
      api.reload('5954443c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5954443c&", function () {
      api.rerender('5954443c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/index.vue"
export default component.exports